console.log('common');
const reveals = document.querySelectorAll('.reveal');

function checkOS() {
    let os = 'other';

    if (navigator.userAgent.includes('iPhone')) {
        os = 'ios';
        console.log('ios');
    } else if (navigator.userAgent.includes('Android') || navigator.userAgent.includes('android')) {
        os = 'android';
        console.log('android');
    }

    return os;
    // const getMobileOS = () => {
    //     const ua = navigator.userAgent
    //     if (/android/i.test(ua)) {
    //         return "Android"
    //     } else if (/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1){
    //         return "iOS"
    //     }
    //     return "Other"
    // }
}

function getBrowser() {
    const userAgent = navigator.userAgent;
    let browser = 'unkown';
    // Detect browser name
    browser = /ucbrowser/i.test(userAgent) ? 'UCBrowser' : browser;
    browser = /edg/i.test(userAgent) ? 'Edge' : browser;
    browser = /googlebot/i.test(userAgent) ? 'GoogleBot' : browser;
    browser = /chromium/i.test(userAgent) ? 'Chromium' : browser;
    browser = /firefox|fxios/i.test(userAgent) && !/seamonkey/i.test(userAgent) ? 'Firefox' : browser;
    browser = /; msie|trident/i.test(userAgent) && !/ucbrowser/i.test(userAgent) ? 'IE' : browser;
    browser = /chrome|crios/i.test(userAgent) && !/opr|opera|chromium|edg|ucbrowser|googlebot/i.test(userAgent) ? 'Chrome' : browser;
    browser = /safari/i.test(userAgent) && !/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(userAgent) ? 'Safari' : browser;
    browser = /opr|opera/i.test(userAgent) ? 'Opera' : browser;

    return browser;
}

function callback(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            setTimeout(() => {
                entry.target.classList.add('show');
            }, 150);
        }
    });
}

if (getBrowser() !== 'Safari') {
    reveals.forEach(element => {
        new IntersectionObserver(callback, {
            root: null,
            rootMargin: '0px 0px -25% 0px',
            threshold: 0.5,
        }).observe(element);
    });
} else {
    reveals.forEach(element => element.classList.add('show'));
}

export { checkOS };
